export function isWaypointLimitReached(state) {
    return state.isWaypointLimitReached
}

export function waypointPositions(state) {
    return state.waypointPositions
}

export function searchId(state) {
    return state.searchId
}

export function lastSearches(state) {
    return state.lastSearches
}

export function lastRoutes(state) {
    return state.lastRoutes
}

export function singleLocationSelected(state) {
    return (state.waypointPositions.start && !state.waypointPositions.end) || (!state.waypointPositions.start && state.waypointPositions.end);
}